import Login from "./views/Login.vue";
import Forget from "./views/Forget.vue";
import Register from "./views/Register.vue";
import NotFound from "./views/404.vue";
// import Home from './views/Home.vue'
import Main from "./views/Main.vue";

import LoginAdmin from "./views/LoginAdmin.vue";
import Account from "./views/administrator/account/Account";
import Company from "./views/administrator/account/Company";
import UserCom from "./views/administrator/account/UserCom";
import UserDetail from "./views/administrator/account/userDetail";
import moduleDetail from "./views/administrator/console/assembly/moduleDetail";
import moduleUserDetail from "./views/administrator/console/assembly/moduleUserDetail";

import Admin from "./views/administrator/admin/Admin";
import Module from "./views/administrator/module/Module";
import Menu from "./views/administrator/menu/Menu";
import Urls from "./views/administrator/urls/Urls";
import ProductList from "./views/administrator/productList/ProductList";
import Management from "./views/administrator/Management";
import OrderList from "./views/administrator/orderList/OrderList";
import OrderAdd from "./views/administrator/orderList/OrderAdd";
import OrderEdit from "./views/administrator/orderList/OrderEdit";
import OrderDetail from "./views/administrator/orderList/OrderDetail";

import AIRilab from "./views/administrator/AIRilab/AIRilab.vue";
import PdfTrans from "./views/administrator/AIPdf/AIPdf.vue"

import exchange from "./views/integral/exchange";
import creditsQuery from "./views/credits/query";
import userIntegral from "./views/integral/userIntegral";

import AuthorizeList from "./views/administrator/authorizeList/AuthorizeList";
import ComorizeList from "./views/administrator/authorizeList/ComorizeList";

import ApplyTrial from "./views/administrator/apply/ApplyTrial";
import TargetCustom from "./views/administrator/account/targetCustom";
import ProbationCustom from "./views/administrator/account/probationCustom";
import OfficialCustom from "./views/administrator/account/officialCustom";
import ProbationView from './views/administrator/account/probationView'
import OfficalView from './views/administrator/account/officalView'
let routes = [
  {
    path: "/loginAdmin",
    component: LoginAdmin,
    name: "",
    hidden: true,
  },
  // {
  //     path: '/login',
  //     component: Login,
  //     name: '',
  //     hidden: true
  // },
  // {
  //     path: '/forget',
  //     component: Forget,
  //     name: '',
  //     hidden: true
  // },
  // {
  //     path: '/register',
  //     component: Register,
  //     name: '',
  //     hidden: true
  // },
  {
    path: "/404",
    component: NotFound,
    name: "",
    hidden: true,
  },
  // { path: '/main', component: Main,name:'控制台' },

  {
    path: "/",
    component: () => import("./views/Home2.vue"),
    name: "我的产品",
    // meta: {
    //     requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
    // },

    children: [
      {
        path: "dailyStatistics",
        component: () =>
          import("./views/administrator/console/dailyStatistics"),
        name: "日活统计",
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "enterLoadIndex",
        component: () => import("./views/administrator/console/enterLoadIndex"),
        name: "企业负载率指标",
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "activityWarn",
        component: () => import("./views/administrator/console/activityWarn"),
        name: "活跃度预警",
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "moduleIntegral",
        component: () => import("./views/administrator/console/moduleIntegral"),
        name: "模块积分统计",
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "integralStatistics",
        component: () =>
          import("./views/administrator/console/integralStatistics"),
        name: "积分统计",
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "salesWall",
        component: () => import("./views/administrator/console/salesWall"),
        name: "销售挂图",
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "userStatistics",
        component: () => import("./views/administrator/console/userStatistics"),
        name: "用户统计",
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "management",
        component: Management,
        name: "控制台",
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "module",
        component: Module,
        name: "模块管理",
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "productList",
        component: ProductList,
        name: "产品管理",
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "authorizeList",
        component: AuthorizeList,
        name: "个人产品",
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "comorizeList",
        component: ComorizeList,
        name: "企业产品",
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "exchange",
        component: exchange,
        name: "积分兑换",
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "credits",
        component: creditsQuery,
        name: "积分查询",
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "userIntegral",
        component: userIntegral,
        name: "用户积分明细",
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "orderList",
        component: OrderList,
        name: "订单管理",
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "AIRilab",
        component: AIRilab,
        name: "AI效果图管理",
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "PdfTrans",
        component: PdfTrans,
        name: "PDF转换管理",
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "orderAdd",
        component: OrderAdd,
        name: "新增订单",
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "orderDetail",
        component: OrderDetail,
        name: "订单详情",
        meta: {
          requireAuth: true,
        },
      },
      {
        // path: 'orderEdit/:id',
        path: "orderEdit",
        component: OrderEdit,
        name: "编辑订单",
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "admin",
        component: Admin,
        name: "管理员管理",
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "account",
        component: Account,
        name: "用户管理",
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "targetCustom",
        component: TargetCustom,
        name: "目标客户池",
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "probationCustom",
        component: ProbationCustom,
        name: "试用客户管理",
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "officialCustom",
        component: OfficialCustom,
        name: "正式客户管理",
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "company",
        component: Company,
        name: "企业管理",
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "userCom",
        component: UserCom,
        name: "客户管理",
        hidden: true,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "probationView",
        component: ProbationView,
        name: "客户管理",
        hidden: true,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "officalView",
        component: OfficalView,
        name: "客户管理",
        hidden: true,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "userDetail",
        component: UserDetail,
        name: "用户详情",
        hidden: true,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "moduleDetail",
        component: moduleDetail,
        name: "模块积分统计",
        hidden: true,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "moduleUserDetail",
        component: moduleUserDetail,
        name: "模块积分统计",
        hidden: true,
        meta: {
          requireAuth: true,
        },
      },

      {
        path: "menu",
        component: Menu,
        name: "软件类型",
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "urls",
        component: Urls,
        name: "系统管理",
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "applyTrial",
        component: ApplyTrial,
        name: "试用申请",
        meta: {
          requireAuth: true,
        },
      },
    ],
  },
  { path: "*", redirect: "/" },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js